// =========================================================================================@@
// Last Updated Date: Feb 28, 2023
// Last Updated By: Steven Yuen
// Status Level: 1
// ===========================================================================================

import React from 'react'
import { css } from 'emotion'
import { Text, View } from 'oio-react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { InitiativeDiscussionIcon } from 'assets/icons'
import InitiativeDefaultThumbnail from 'src/sites/kits/Initiative/components/DefaultThumbnail'
import ObjectPrivacyBadge from 'src/sites/kits/Object/components/PrivacyBadge'
import { Title } from 'src/sites/kits/UI'

const InitiativeListItemRowSmall = ({
   archived,
   borderStyle,
   coverUrl,
   dateLastUpdated,
   hideThumbnail,
   initiativeTypeHighlightColor,
   initiativeTypeIconName,
   linkTo,
   name,
   numThreadEntries,
   privacy,
   showStats
}) => (
   <Link to={linkTo}>
      <View
         display="flex"
         alignItems="flex-start"
         width="100%"
         padding="15px 0px"
         borderTop={borderStyle}
         className={css`
            &:hover {
               background-color: rgba(56, 170, 242, 0.03);
            }
         `}>
         {!hideThumbnail && (
            <View
               flex="0 0 auto"
               width="30px"
               height="30px"
               borderRadius="4px"
               backgroundColor="#eee"
               backgroundImage={`url(${coverUrl})`}
               backgroundSize="cover"
               backgroundPosition="center center"
               marginRight="15px"
               marginTop="2px"
               style={{ overflow: 'hidden' }}>
               {!coverUrl && (
                  <InitiativeDefaultThumbnail
                     highlightColor={initiativeTypeHighlightColor}
                     iconName={initiativeTypeIconName}
                  />
               )}
            </View>
         )}
         <View
            display="flex"
            flex="1 1 auto"
            opacity={archived && '0.5'}>
            <View flex="1 1 auto">
               <View display="flex" alignItems="center">
                  <Title size="xs">
                     {name}
                  </Title>
                  {archived && (
                     <View
                        display="inline-flex"
                        alignItems="center"
                        height="15px"
                        border="1px solid #ddd"
                        padding="0px 5px"
                        borderRadius="3px"
                        marginLeft="10px">
                        <Text size="0.7" weight="bold" transform="uppercase" color="#777">
                           Archived
                        </Text>
                     </View>
                  )}
               </View>
               <View className="ui-meta-text" width="100%">
                  <ObjectPrivacyBadge privacy={privacy} />
                  {`Last updated ${dateLastUpdated}`}
               </View>
            </View>
            {showStats && (
               <View
                  display="flex"
                  alignItems="center"
                  paddingLeft="30px[c-f]"
                  flex="0 0 auto">
                  {numThreadEntries > 0 && (
                     <View display="flex" alignItems="center">
                        <View marginRight="5px">
                           <InitiativeDiscussionIcon
                              width="10px"
                              height="10px"
                              color="#aaa"
                           />
                        </View>
                        <Text size="1" color="#aaa">
                           {numThreadEntries}
                        </Text>
                     </View>
                  )}
               </View>
            )}
         </View>
      </View>
   </Link>
)

InitiativeListItemRowSmall.propTypes = {
   archived: PropTypes.bool,
   borderStyle: PropTypes.string,
   coverUrl: PropTypes.string,
   dateLastUpdated: PropTypes.string.isRequired,
   hideThumbnail: PropTypes.bool,
   initiativeTypeHighlightColor: PropTypes.string,
   initiativeTypeIconName: PropTypes.string,
   linkTo: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   numThreadEntries: PropTypes.number,
   privacy: PropTypes.string.isRequired,
   showStats: PropTypes.bool
}

InitiativeListItemRowSmall.defaultProps = {
   archived: false,
   borderStyle: '1px solid var(--primaryLineColor)',
   coverUrl: undefined,
   hideThumbnail: false,
   initiativeTypeHighlightColor: undefined,
   initiativeTypeIconName: undefined,
   numThreadEntries: undefined,
   showStats: true
}

export default InitiativeListItemRowSmall
